<template>
  <TranslationListSection :title="section.label">
      <PaginatedList
         itemClass="translation-item"
         :items="section.keys"
         :filterItemsFn="filterFn"
      >
        <template #item="{ item }">
            <TranslationKey
              :item="item"
              @showValueLogs="showValueLogs"
              @change="onChange"
            />            
        </template>
      </PaginatedList>

      <ValueLogModal
        ref="logModal"
        :loading="isLogLoading"
        :changelog="logData"
        :adjustedTimeZone="false"
        @close="setValueLogs"
      />
    </TranslationListSection>
</template>

<script>
import { mapActions } from "vuex";
import ValueLogModal from "@shared/components/form-builder/components/FieldValueLogModal";
import PaginatedList from './paginated-list';
import TranslationListSection from './expanded-section.vue';
import TranslationKey from './translation-key.vue';

export default {
  name: 'TranslationListItem',
  components: {
    TranslationListSection,
    TranslationKey,
    ValueLogModal,
    PaginatedList
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    filterFn: {
      type: Function,
      default: (list)=> (list),
    }
  },
  data() {
      return {
          logData: null,
          isLogLoading: false
      };
  },
  inject: ['langProfile'],
  computed: {
    langProfileId() {
      return this.langProfile()?.language_profile_id;
    },
  },
  methods: {
    ...mapActions({
      fetchTranslationKeyChangeHistory: 'LocalizationStore/fetchTranslationKeyChangeHistory',
    }),
    async showValueLogs(itemKey){
      const fullKey = `${this.section.id}.${itemKey}`;
      this.isLogLoading = true;
      try {
        const response = await this.fetchTranslationKeyChangeHistory({
          lang_profile_id: this.langProfileId,
          key: fullKey,
        });
        this.$refs.logModal.showModal();
        const logData = response
          .map(this.formatChangeRecordData);
        this.setValueLogs(logData);
      } catch (error) {
        console.error('Failed to fetch value logs', error);
      }
      this.isLogLoading = false;
    },
    setValueLogs(payload = null) {
      this.logData = payload;
    },
    onChange(payload) {
      this.$emit('change', {
        key: payload.id,
        value: payload.value,
        section: this.section.id,
      });
    },
    formatChangeRecordData(payload) {
      return {
        ...payload,
        timestamp: payload.modified_at,
        user_name: payload.user_name || this.$t('components.dashboard.system'),
        new_value: payload.translation_after,
        previous_value: payload.translation_before,
      }
    },
  }
};
</script>
<style lang="scss">
.list_item.translation-item {
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity))!important;
}
</style>
